import type { MockEndpointConfig } from './models/mock.model';
import { CENSUS_LINE_SCENARIOS } from './scenarios/census-line.scenarios';
import { HOTLINE_SCENARIOS } from './scenarios/hotline.scenarios';
import { PERSON_SCENARIOS } from './scenarios/person.scenarios';
import { VALIDATION_ENDPOINT_PATH } from '../constants/public-endpoints';
import { VALIDATION_SCENARIOS } from './scenarios/validation.scenarios';

export const MOCK_REGISTRY: Record<string, MockEndpointConfig> = {
  censusLine: {
    label: 'Census Line API',
    urlPattern: '/CensusLines/Customer',
    scenarios: CENSUS_LINE_SCENARIOS,
    scenarioDescriptions: {
      TC_3_1: 'Cambodia example — 3 phone pills + accordion text',
      TC_3_2: 'Short instructions with single phone pill',
      TC_3_3: 'Online submission — URL + Vienna address, no phone pills',
      TC_3_4: 'Bulgaria/WTW France — 00-prefix hotline as one phone pill',
      TC_4_1: 'No claimsInstructions → section hidden',
      TC_4_2: 'Empty claimsInstructions → section hidden'
    }
  },

  hotline: {
    label: 'Hotline API',
    urlPattern: '/Policies/PersonHotline',
    scenarios: HOTLINE_SCENARIOS,
    scenarioDescriptions: {
      TC_1_1: 'Health — 4 phones (US/Canada + Turkey)',
      TC_1_2: 'Health — 2 phones (Worldwide + US/Canada)',
      TC_1_3: 'Health — duplicate phone, different services (Georgia)',
      TC_1_4: 'Student — single phone',
      TC_1_5: 'Travel — 2 phones (Worldwide + Mexico/US/Canada)',
      TC_1_6: 'Health — 3 phones (Worldwide + Turkey)',
      TC_1_7: 'Health — 2 phones (Worldwide + Serbia)',
      TC_1_8: '2 policies — Student (number-only) + Health (Worldwide + US/Canada)',
      TC_1_9: '3 policies — Student + Travel + Health (4 phones Turkey)',
      TC_1_10: '4 policies — mixed number-only and multi-number',
      TC_1_11: 'Health — 5 phones with mixed separators (dots, hyphens, spaces, none)',
      TC_2_1: 'Empty array → Feature Unavailable modal'
    }
  },

  person: {
    label: 'Person API',
    urlPattern: '/CustomerProfile/Person',
    scenarios: PERSON_SCENARIOS,
    scenarioDescriptions: {
      TC_1_1: 'Terms + telemedicine consent accepted — no consent modal',
      TC_1_2: 'Terms not accepted — privacy policy modal (Accept / Log Out)',
      TC_1_3: 'Telemedicine consent missing/revoked — legal documents consent modal'
    }
  },

  validation: {
    label: 'QR Validation API',
    urlPattern: VALIDATION_ENDPOINT_PATH,
    scenarios: VALIDATION_SCENARIOS,
    scenarioDescriptions: {
      TC_1_1: 'Full payload — master policyholder + 1 census line',
      TC_1_2: 'No master policyholder + 2 census lines'
    }
  }
};
